module.exports = __webpack_public_path__ + "img/EMC_HG_2.834e436c.png";